<template>
    <div class="bg-light p-3 d-flex justify-content-between align-items-center" @click="setCurrentPaymentMethod">
        <div v-if="newCard">
            New Card
        </div>
        <div v-else>
            <div class="d-flex align-items-center">
                <b-img :src="cardBrandUrl" class="credit-card-avatar"/>
                <div class="d-flex flex-column ml-3">
                    <b>{{paymentMethod.name}}</b>
                    <div>**** **** **** {{paymentMethod.last_four}}</div>
                </div>
            </div>
        </div>

        <b-form-radio name="payment-method-select"
                      :value="paymentMethod"
                      :disabled="disabled"
                      v-model="localSelected"/>
    </div>
</template>

<script>
  import AssetLoader from "../../../../AssetLoader";

  export default {
    props: ['paymentMethod', 'value', 'disabled'],

    methods: {
      setCurrentPaymentMethod: function() {
        if (!this.disabled) {
          this.localSelected = this.paymentMethod;
        }
      }
    },

    computed: {
      newCard: function () {
        return this.paymentMethod === 'newCard'
      },

      cardBrandUrl: function () {
        return AssetLoader.imagePath(`cards/${this.paymentMethod.brand}.png`);
      },

      localSelected: {
        get() {
          return this.value
        },
        set(selected) {
          this.$emit('input', selected)
        }
      }
    },
  }
</script>